import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">GalleryJS · Your Creative Hub</p>
        <h1>Unleash Your Creativity.</h1>
        <p className="lede">
          Welcome to GalleryJS, where your artistic vision comes to life. Explore, create, and share your unique creations with a vibrant community of fellow creators.
        </p>
        <div className="cta-row">
          <a href="https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html" target="_blank">
            Get Started
          </a>
          <a href="https://github.com/skighnet" target="_blank" className="secondary">
            Explore GalleryJS
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Showcase Your Work</h2>
          <p>
            Create a stunning portfolio to display your art, photography, or design projects. Let your work shine and attract the attention it deserves.
          </p>
        </article>
        <article>
          <h2>Connect with Creatives</h2>
          <p>
            Join a community of like-minded individuals. Share ideas, collaborate on projects, and gain inspiration from others in the creative space.
          </p>
        </article>
        <article>
          <h2>Grow Your Audience</h2>
          <p>
            Utilize our tools to promote your work and reach a wider audience. Engage with followers and turn your passion into a thriving creative career.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;